module.exports = __webpack_public_path__ + "bg-big_sale.jpg";